import Vue from 'vue'
import {
  Field,
  Form,
  Picker,
  Button,
  Popup,
  Dialog
} from 'vant'

export default () => {
  let els = [
    Field,
    Form,
    Picker,
    Button,
    Popup,
    Dialog
  ]
  // 注册
  els.forEach((item) => {
    Vue.use(item)
  })
}
